import { useState } from 'react';
import { v4 } from 'uuid';

export const useUniqueId = (prefix: string) => {
  const [uniqueId] = useState(`${prefix}-${v4()}`);

  return uniqueId;
};
